import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { PreviewNotice, CartLines, OrderTotals, PurchasePreference, EmptyCart } from "@/components/Commerce";
import "@/commerce.css";
export default function Cart() {
  const { items, count } = useCart();
  if (!items.length) return <EmptyCart />;
  return <main className="commerce-page"><Link to="/?section=products">← Continue shopping</Link><h1>Your cart <span>({count})</span></h1><PreviewNotice />
    <div className="commerce-grid"><section className="commerce-panel" aria-label="Cart items"><CartLines editable /></section>
      <aside className="commerce-panel"><h2>Order summary</h2><PurchasePreference /><OrderTotals /><Link className="commerce-button" to="/checkout">Checkout</Link></aside></div>
  </main>;
}

